import { cn } from '@/shared/lib/utils';

/**
 * The outer wrapper for every page.
 *
 * Owns page padding and max width so that no page re-invents its own spacing
 * and the whole admin lines up (§61). Pages supply content only.
 */
export function PageContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn('flex flex-col gap-5 p-4 sm:p-6', className)}>{children}</div>;
}
